import React, { useEffect } from 'react';
import { OneWorldSyncEnergyLabelProps, OneWorldSyncLoaderInfoProps } from 'types/OneWorldSyncLoaderTypes';
import loadOneWorldSync from 'utilities/oneWorldSync/oneWorldSync-util';
import styles from './EnergyLabel.module.css';

function EnergyLabel(props: OneWorldSyncEnergyLabelProps) {
  const { brand, mpn, ean, option, site } = props;

  useEffect(() => {
    if (brand) {
      const loaderInfo: OneWorldSyncLoaderInfoProps = {
        brand,
        window,
        option,
        mpn,
        ean,
        site,
      };
      loadOneWorldSync(loaderInfo);
    }
  }, [brand]);

  return (
    <div id="cnet-energyInfo" data-testid="oneworldsync-energy-label" className={styles.wrapper}>
      <div id="ccs-logos" />
      <div id="ccs-product-fiche" />
    </div>
  );
}

export default EnergyLabel;
